export const REMARK_URL = ''
export const REMARK_HOST = 'https://remark1991.com'
export const FAKE_API_URL = 'http://localhost:3000'